/**
 *  试卷模块
 */
import http from '../assets/js/http'
// 试卷分类列表
export const getClassifyList = (params) => { return http.request({ url: '/examPaper/classify/getList', method: 'get', params: params }) }
// 保存试卷分类
export const saveClassify = (params) => { return http.request({ url: '/examPaper/classify/save', method: 'post', params: params, headers: { 'Content-Type': 'application/json;charset=utf-8' } }) }
// 试卷列表
export const getList = (params) => { return http.request({ url: '/examPaper/getList', method: 'get', params: params }) }
// 试卷信息
export const info = (params) => { return http.request({ url: '/examPaper/info', method: 'get', params: params }) }
// 试卷详情
export const detail = (params) => { return http.request({ url: '/examPaper/detail', method: 'get', params: params }) }
// 试卷保存
export const save = (params) => { return http.request({ url: '/examPaper/save', method: 'post', params: params, headers: { 'Content-Type': 'application/json;charset=utf-8' } }) }
// 复制保存
export const copy = (params) => { return http.request({ url: '/examPaper/copy', method: 'post', params: params }) }
// 试卷删除
export const remove = (params) => { return http.request({ url: '/examPaper/remove', method: 'post', params: params }) }
// 检查是否存在数据
export const checkExistsData = (params) => { return http.request({ url: '/examPaper/classify/checkExistsData', method: 'get', params: params }) }
